import { render } from "./HomePageComponent.vue?vue&type=template&id=c2d44b08"
import script from "./HomePageComponent.vue?vue&type=script&lang=js"
export * from "./HomePageComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\_Hamza\\_Code\\HealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__